import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import CheckJoinCampaign from './CheckJoinCampaign';
import DailyStreakScreen from './DailyStreak/DailyStreakScreen';
import TradingChallengeHeader from './TradingChallengeHeader';
import Volume from './Volume/Volume';

const VolumeChallengeScreen: React.FC = () => {
    const navigate = useNavigate();

    const { t } = useTranslation();

    const [activeTab, setActiveTab] = useState<'Volume' | 'Daily Streak'>(
        'Volume'
    );

    const handleGoToTrade = () => {
        navigate('/future');
    };

    return (
        // Toàn bộ màn hình
        <div className="min-h-screen bg-black pb-20">
            <TradingChallengeHeader
                activeTab={activeTab}
                onTabChange={setActiveTab}
            />

            {/* <div className="pb-[100px] overflow-auto h-[80vh] ">
                <Volume />
            </div> */}

            {activeTab === 'Volume' && (
                <div className="pb-[100px] overflow-auto h-[80vh] ">
                    <Volume />
                </div>
            )}

            {activeTab === 'Daily Streak' && (
                <div className="pb-[100px] overflow-auto h-[80vh] ">
                    <DailyStreakScreen />
                </div>
            )}

            <button
                type="button"
                className="fixed bottom-0 left-0 right-0 mx-4 my-4 p-2.5 
                         bg-white text-black font-medium text-lg rounded-full shadow-2xl z-20 
                         transition-transform hover:scale-[1.01] active:scale-95"
                onClick={handleGoToTrade}
            >
                {t('Go To Trade')}
            </button>
            <CheckJoinCampaign />
        </div>
    );
};

export default VolumeChallengeScreen;
